import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

import EllipsisMenu       from 'app/components/common/ellipsis-menu';
import Icon               from 'app/components/common/icon';
import Link               from 'app/components/common/link';
import Meta               from 'app/components/common/meta';
import Pagination         from 'app/components/common/pagination';
import StandardSelect     from 'app/components/common/standard-select';
import ScrollTable        from 'app/components/common/scroll-table';
import CadminLayout       from 'app/components/company-admin/layout/';
import PageLoading        from 'app/components/layout/page-loading';
import ProgramCard        from 'app/components/grant-system/program-card';
import FormsDuck          from 'app/ducks/company-admin/forms';
import UiFormsDuck        from 'app/ducks/company-admin/ui-forms';
import GrantSysDuck       from 'app/ducks/company-admin/grant-system';
import formsHelpers       from 'app/helpers/forms';
import Ps                 from 'app/helpers/publish-statuses';
import paths              from 'app/paths';
import CadminSlx          from 'app/selectors/company-admin/';
import ModalProgramEdit   from 'app/components/company-admin/grant-system/modal-program-edit';

const tabs = [Ps.DRAFT, Ps.ACTIVE, Ps.ARCHIVED];
const psOptions = [
  {value: Ps.DRAFT, label: Ps.name(Ps.DRAFT)},
  {value: Ps.ACTIVE, label: Ps.name(Ps.ACTIVE)},
  {value: Ps.ARCHIVED, label: Ps.name(Ps.ARCHIVED)},
];

class CadminPageGrantPrograms extends React.PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      showNewModal: false,
      cattrs: {},
      publishStatus: 'active',
    };

    this.onClickTab = this.onClickTab.bind(this);
    this.onClickNewProgram = this.onClickNewProgram.bind(this);
    this.onCloseNewProgram = this.onCloseNewProgram.bind(this);
  }

  onClickNewProgram() {
    this.setState({showNewModal: true});
  }
  onCloseNewProgram(didSubmit=false) {
    this.setState({showNewModal: false});
  }

  onChangeCattr(cattrId, optId) {
    this.setState((prevState) => {
      return {cattrs: {...prevState.cattrs,
        [cattrId]: optId,
      }};
    });
  }

  onClickTab(publishStatus, event) {
    event && event.preventDefault();
    this.setState({publishStatus});
  }

  get programs() {
    const {programs} = this.props;
    const cattrPairs = Object.entries(this.state.cattrs).filter(([cid, oid]) => !!oid);
    if (!programs) return null;
    return programs.filter((program) => {
      if (program.publishStatus !== this.state.publishStatus) return false;
      for (let i = 0; i < cattrPairs.length; i++) {
        const [cattrId, optId] = cattrPairs[i];
        if (program.cattrs[cattrId] !== optId) return false;
      }
      return true;
    });
  }

  renderTable() {
    const {company} = this.props;
    const {programs} = this;
    if (!programs) return <Icon.Loading className="ca-box-loading" />;

    return (
      <ScrollTable className="ca-box-table">
        <thead>
          <tr>
            <th>Title</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {programs.map((program) => {
            const managePath = paths.cadminGrantProgram(company.slug, program.id);
            return (
              <tr key={program.id}>
                <td>
                  <div className="menu-cell">
                    <Link className="pink-hover" href={managePath}>{program.title}</Link>
                    <EllipsisMenu usePortal>
                      <Link href={managePath}><Icon.Cog1 />Manage</Link>
                      <Link href={paths.grantProgram(program.id)}><Icon.BrowserPageText />Public Page</Link>
                    </EllipsisMenu>
                  </div>
                </td>
                <td>{program.publishStatus}</td>
              </tr>
            );
          })}
        </tbody>
      </ScrollTable>
    );
  }

  render() {
    const {company, cattrs} = this.props;
    const {showNewModal} = this.state;
    if (!company) return <PageLoading />;

    return (
      <CadminLayout company={company} activeItem="grant-programs">
        <Meta title={`Grant Programs | Millie`} />
        <div className="ca-main-head">
          <h1 className="ca-main-head-h1">Grant Programs</h1>
          <div className="ca-main-head-actions">
            {!!company.grantsPublicProgramsPageEnabled && (
              <Link href={paths.grantPrograms(company.slug)} className="btn blue secondary">Public Page</Link>
            )}
            <button className="btn blue" onClick={this.onClickNewProgram}>New Program</button>
          </div>
        </div>

        <div className="ca-main-filters">
          <div className="ca-main-filters-filter">
            <label className="ca-main-filters-filter-label">Status</label>
            <StandardSelect options={psOptions} value={this.state.publishStatus} onSelect={this.onClickTab} />
          </div>
          {cattrs.map((cattr) => {
            const value = this.state.cattrs[cattr.id];
            return (
              <div key={cattr.id} className="ca-main-filters-filter">
                <label className="ca-main-filters-filter-label">{cattr.label}</label>
                <StandardSelect options={cattr.options} onSelect={this.onChangeCattr.bind(this, cattr.id)} value={value} label="All" allowClear />
              </div>
            );
          })}
        </div>

        <div className="_flex _align-stretch _justify-start _gap-24 _flex-wrap _mt-48">
          {!(this.programs || []).length && (
            <p className="_italic">No programs found. Try clearing some filters.</p>
          )}
          {(this.programs || []).map((program) => {
            const stats = this.props.programStats[program.id] || this.props.programStats.default;
            return (
              <ProgramCard key={program.id} program={program} stats={stats} isAdmin company={company} />
            );
          })}
        </div>

        {/* <pre>{JSON.stringify({programStats: this.props.programStats}, null, 4)}</pre> */}

        {/* <div className="ca-box"> */}
        {/*   <div className="ca-box-header"> */}
        {/*     <h1 className="ca-box-header-title">Grant Programs</h1> */}
        {/*     <div className="ca-box-header-controls"></div> */}
        {/*   </div> */}
        {/*   <div className="ca-box-tabs"> */}
        {/*     <div className="ca-box-tabs-tabs"> */}
        {/*       {tabs.map((tab) => { */}
        {/*         const activeClass = (tab === this.state.publishStatus) ? 'active' : ''; */}
        {/*         return <a href="#" key={tab} onClick={this.onClickTab.bind(this, tab)} className={`ca-box-tabs-tab ${activeClass}`}>{Ps.name(tab)}</a> */}
        {/*       })} */}
        {/*     </div> */}
        {/*   </div> */}
        {/*   <div className="ca-box-body"> */}
        {/*     {this.renderTable()} */}
        {/*   </div> */}
        {/* </div> */}

        {showNewModal && (
          <ModalProgramEdit company={company} onClose={this.onCloseNewProgram} />
        )}
      </CadminLayout>
    );
  }

}

const stateToProps = (state) => ({
  company: CadminSlx.company(state),
  programs: GrantSysDuck.Slx.allPrograms(state),
  cattrs: GrantSysDuck.Slx.cattrs(state),
  programStats: GrantSysDuck.Slx.programStats(state),
});
const dispatchToProps = (dispatch) => ({});

export default connect(stateToProps, dispatchToProps)(CadminPageGrantPrograms);
